module.exports = __webpack_public_path__ + "static/img/1_2_1.ca610e06.jpg";